import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

import { LogoMain } from '../'
import chevronUpIcon from '../../assets/icons/chevron-up.svg'
import './NavigationMenuMobile.sass'


class NavigationMenuMobile extends Component {
  state = {
    isResourceMenuExpanded: false
  }

  constructor() {
    super()

    this._toggleResourceMenu = this.toggleResourceMenu.bind(this)
  }

  toggleResourceMenu(e) {
    e.preventDefault()
    e.stopPropagation()  // don't want click event to get picked up by anchor tag (Navlink)
    this.setState({ isResourceMenuExpanded: !this.state.isResourceMenuExpanded })
  }

  render() {
    const { isResourceMenuExpanded } = this.state

    return (
      <nav className="navigation-menu navigation-menu-mobile" role="navigation">
        <LogoMain containerClassName="logo" />
        <NavLink to="/about" activeClassName="is-active-link">About the Project</NavLink>
        <NavLink to="/resources" activeClassName="is-active-link">
          Resources
          <button
            type="button"
            onClick={this._toggleResourceMenu}
            aria-label="toggle sub-menu"
            className={`resource-list-toggle ${isResourceMenuExpanded && 'is-expanded'}`}
          >
            <img src={chevronUpIcon} alt="toggle arrow" />
          </button>
        </NavLink>
        <div className={`resource-links ${isResourceMenuExpanded ? 'is-expanded' : ''}`}>
          <NavLink to="/resources/glossary" className="resource-link">Glossary</NavLink>
          <NavLink to="/resources/case-studies" className="resource-link">Case Study Libraries</NavLink>
          <NavLink to="/resources/resource-libraries" className="resource-link">Resource Libraries</NavLink>
          <NavLink to="/resources/data-sources" className="resource-link">Data Sources</NavLink>
          <NavLink to="/resources/faqs" className="resource-link">FAQs</NavLink>
          <NavLink to="/resources/retired-tools" className="resource-link">Retired Tools</NavLink>
        </div>
        <NavLink to="/partners" activeClassName="is-active-link">Partners</NavLink>
        <NavLink to="/funding" activeClassName="is-active-link">Funding</NavLink>
        <NavLink to="/contact" activeClassName="is-active-link">Contact</NavLink>
      </nav>
    )
  }
}

export default NavigationMenuMobile
